import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LockIcon from '@mui/icons-material/Lock';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { ChoiceDialogProps } from '../../../components/ChoiceDialog';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { RequestBurnDialog } from '../burn/RequestBurnDialog';
import { OfferTransferForm } from '../transfer/OfferTransferForm';

export const useCreateHoldingsActions = (
  onClose: () => void,
  selectedRow?: TemplateContract<Holding>,
) => {
  const actions: ChoiceDialogProps['actions'] = [];
  const { party } = useParties();

  if (!selectedRow) {
    return [];
  }
  if (selectedRow.payload.owner === party) {
    if (!selectedRow.payload.lock) {
      actions.push(
        {
          name: 'Transfer',
          form: <OfferTransferForm onClose={onClose} holding={selectedRow} />,
          icon: <CompareArrowsIcon color="inherit" fontSize="small" />,
          variant: 'contained',
        },
        {
          name: 'Burn',
          form: <RequestBurnDialog open onClose={onClose} disableDialog holding={selectedRow} />,
          icon: <WhatshotIcon color="inherit" fontSize="small" />,
          variant: 'contained',
        },
      );
    } else {
      actions.push({
        name: 'Locked',
        icon: <LockIcon color="disabled" />,
        disabled: true,
      });
    }
    return actions;
  }
  return actions;
};
